import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

//加密解密开始
import AES from "../utils/AES.js"; // 引入


const originalPush = Router.prototype.push;
const originalreplace = Router.prototype.replace;

Router.prototype.push = function push(location, onResolve, onReject) {
  
  let newLocation = location;
   if(newLocation.query ){
    
    for (const key in newLocation.query){
      newLocation.query[key] = AES.encrypt(
        newLocation.query[key].toString() 
      
      )
    }
    
    return originalPush.call(this, newLocation);
  }else{
    return originalPush.call(this, newLocation);

  }
  

}
Router.prototype.replace = function replace(location, onResolve, onReject) {
  
  let newLocation = location;
   if(newLocation.query ){
    
    for (const key in newLocation.query){
      newLocation.query[key] = AES.encrypt(
        newLocation.query[key].toString() 
      
      )
    }
    
    return originalreplace.call(this, newLocation);
  }else{
    return originalreplace.call(this, newLocation);

  }
  

}
export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'index',
      meta:{
        title:'首页',
				requireAuth: true,
      },
      component: () =>import ('@/views/index/index.vue')
    },   {
      path: '/year_index',
      name: 'year_index',
      meta:{
        title:'年度培训',
				requireAuth: true,
      },
      component: () =>import ('@/views/year_learn/index.vue')
    }, {
      path: '/year_learn',
      name: 'year_learn',
      meta:{
        title:'年度培训',
				requireAuth: true,
      },
      component: () =>import ('@/views/year_learn/learn.vue')
    }, {
      path: '/year_words',
      name: 'year_words',
      meta:{
        title:'年度培训',
				requireAuth: true,
      },
      component: () =>import ('@/views/year_learn/words.vue')
    }, {
      path: '/year_video',
      name: 'year_video',
      meta:{
        title:'年度培训',
				requireAuth: true,
      },
      component: () =>import ('@/views/year_learn/video.vue')
    }, {
      path: '/year_record',
      name: 'year_record',
      meta:{
        title:'年度培训',
				requireAuth: true,
      },
      component: () =>import ('@/views/year_learn/record.vue')
    },{
      path: '/index_exam',
      name: 'index_exam',
      meta:{
        title:'年度培训学习',
				requireAuth: true,
      },
      component: () =>import ('@/views/year_learn/exam.vue')
    },
    {
      path: '/index_result',
      name: 'index_result',
      meta:{
        title:'年度培训学习',
				requireAuth: true,
      },
      component: () =>import ('@/views/year_learn/result.vue')
    },{
      path: '/year_zhengshu',
      name: 'year_zhengshu',
      meta:{
        title:'年度培训学习',
				requireAuth: true,
      },
      component: () =>import ('@/views/year_learn/zhengshu.vue')
    }, {
      path: '/index_peixun',
      name: 'index_peixun',
      meta:{
        title:'年度培训学习',
				requireAuth: true,
      },
      component: () =>import ('@/views/index/index_peixun.vue')
    },  {
      path: '/news',
      name: 'news',
      meta:{
        title:'集团资讯',
		    // requireAuth: true,
      },
      component: () =>import ('@/views/news/news.vue')
    }, {
      path: '/news_detail',
      name: 'news_detail',
      meta:{
        title:'集团资讯详情',
		// requireAuth: true,
      },
      component: () =>import ('@/views/news/detail.vue')
    }, {
      path: '/lows',
      name: 'lows',
      meta:{
        title:'法律法规',
		// requireAuth: true,
      },
      component: () =>import ('@/views/lows/index.vue')
    } , {
      path: '/lowsdetail',
      name: 'lowsdetail',
      meta:{
        title:'法律法规',
		// requireAuth: true,
      },
      component: () =>import ('@/views/lows/detail.vue')
    } ,{
      path: '/renzheng',
      name: 'renzheng',
      meta:{
		requireAuth: true,
        title:'实名认证'
      },
      component: () =>import ('@/views/renzheng/form.vue')
    },{
      path: '/jifen',
      name: 'jifen',
      meta:{
		  requireAuth: true,
        title:'我的积分'
      },
      component: () =>import ('@/views/renzheng/jifen.vue')
    },{
      path: '/myself',
      name: 'myself',
      meta:{
		  requireAuth: true,
        title:'用户中心'
      },
      component: () =>import ('@/views/renzheng/myself.vue')
    },{
      path: '/zhengshu',
      name: 'zhengshu',
      meta:{
		  requireAuth: true,
        title:'我的证书'
      },
      component: () =>import ('@/views/renzheng/zhengshu.vue')
    }, {
      path: '/help',
      name: 'help',
      meta:{
        title:'帮助中心',
		// requireAuth: true,
      },
      component: () =>import ('@/views/help/index.vue')
    }, {
      path: '/index_video',
      name: 'index_video',
      meta:{
        title:'安全教育小视频',
		// requireAuth: true,
      },
      component: () =>import ('@/views/index/video.vue')
    },{
      path: '/index_videolist',
      name: 'index_videolist',
      meta:{
        title:'安全教育小视频',
		// requireAuth: true,
      },
      component: () =>import ('@/views/index/videolist.vue')
    }, {
      path: '/helplist',
      name: 'helplist',
      meta:{
        title:'帮助中心',
		// requireAuth: true,
      },
      component: () =>import ('@/views/help/list.vue')
    }, {
      path: '/helpinfo',
      name: 'helpinfo',
      meta:{
        title:'帮助中心',
		// requireAuth: true,
      },
      component: () =>import ('@/views/help/helpinfo.vue')
    },  {
      path: '/course',
      name: 'course',
      meta:{
        title:'精品课程',
		// requireAuth: true,
      },
      component: () =>import ('@/views/course/index.vue')
    }, {
      path: '/login',
      name: 'login',
      meta:{
        title:'用户登录',
		
      },
      component: () =>import ('@/views/user/login.vue')
    }, {
      path: '/password',
      name: 'password',
      meta:{
        title:'忘记密码',
		
      },
      component: () =>import ('@/views/user/password.vue')
    },{
      path: '/mulu',
      name: 'mulu',
      meta:{
        title:'课程目录',
		requireAuth: true,
      },
      component: () =>import ('@/views/course/mulu.vue')
    },{
      path: '/coursedetail',
      name: 'coursedetail',
      meta:{
        title:'课程详情',
		// requireAuth: true,
      },
      component: () =>import ('@/views/course/detail.vue')
    },{
      path: '/re_face',
      name: 're_face',
      meta:{
        title:'人脸识别',
		
      },
      component: () =>import ('@/views/renzheng/face.vue')
    },{
      path: '/courseword',
      name: 'courseword',
      meta:{
        title:'课程详情',
		// requireAuth: true,
      },
      component: () =>import ('@/views/course/word.vue')
    }
   ,{
     path: '/exam',
     name: 'exam',
     meta:{
       title:'在线考试',
	   requireAuth: true,
     },
     component: () =>import ('@/views/exam/index.vue')
   },{
     path: '/examjilu',
     name: 'examjilu',
     meta:{
       title:'考试记录',
	   requireAuth: true,
     },
     component: () =>import ('@/views/exam/jilu.vue')
   },{
     path: '/test',
     name: 'test',
     meta:{
       title:'在线考试',
	   requireAuth: true,
     },
     component: () =>import ('@/views/exam/test.vue')
   },{
     path: '/testresult',
     name: 'testresult',
     meta:{
       title:'在线考试',
	   requireAuth: true,
     },
     component: () =>import ('@/views/exam/testresult.vue')
   },
	 {
	   path: '/zixundetail',
	   name: 'zixundetail',
	   meta:{
	     title:'新闻资讯',
	   // requireAuth: true,
	   },
	   component: () =>import ('@/views/zixun/detail.vue')
	 },
	 {
	   path: '/zixun',
	   name: 'zixun',
	   meta:{
	     title:'新闻资讯',
	   // requireAuth: true,
	   },
	   component: () =>import ('@/views/zixun/index.vue')
	 },{
	   path: '/learn_plan',
	   name: 'learn_plan',
	   meta:{
	     title:'学习计划',
	   requireAuth: true,
	   },
	   component: () =>import ('@/views/plan/index.vue')
	 },{
	   path: '/pre_in_endication',
	   name: 'pre_in_endication',
	   meta:{
	     title:'入场前置教育',
	   requireAuth: true,
	   },
	   component: () =>import ('@/views/pre_in_endication/index.vue')
	 },{
	   path: '/learn_detail',
	   name: 'learn_detail',
	   meta:{
	     title:'学习计划',
	   requireAuth: true,
	   },
	   component: () =>import ('@/views/plan/detail.vue')
	 },{
	   path: '/learn_mulu',
	   name: 'learn_mulu',
	   meta:{
	     title:'学习计划',
	   requireAuth: true,
	   },
	   component: () =>import ('@/views/plan/mulu.vue')
	 },{
	   path: '/learn_words',
	   name: 'learn_words',
	   meta:{
	     title:'学习计划',
	   requireAuth: true,
	   },
	   component: () =>import ('@/views/plan/words.vue')
	 },{
	   path: '/user_password',
	   name: 'user_password',
	   meta:{
	     title:'学习计划',
	   requireAuth: true,
	   },
	   component: () =>import ('@/views/renzheng/password.vue')
	 },{
	   path: '/check_index',
	   name: 'check_index',
	   meta:{
	     title:'前置审查',
	   requireAuth: true,
	   },
	   component: () =>import ('@/views/check/index.vue')
	 },{
	   path: '/check_form',
	   name: 'check_form',
	   meta:{
	     title:'前置审查',
	   requireAuth: true,
	   },
	   component: () =>import ('@/views/check/form.vue')
	 },{
	   path: '/check_info',
	   name: 'check_info',
	   meta:{
	     title:'前置审查',
	   requireAuth: true,
	   },
	   component: () =>import ('@/views/check/formcheck.vue')
	 },{
	   path: '/formfile',
	   name: 'formfile',
	   meta:{
	     title:'前置审查',
	   requireAuth: true,
	   },
	   component: () =>import ('@/views/check/word.vue')
	 }
 
 
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js